var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangularOpBeveledRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.6673L4 25.0007H27V14.5569C27 12.655 26.2444 10.8309 24.8996 9.48601C23.9596 8.546 22.7103 7.97912 21.3839 7.8907L7.5254 6.9668L4 11.6673ZM6 12.334L8.47461 9.03452L21.2508 9.88627C22.0939 9.94247 22.8879 10.3028 23.4854 10.9002C24.4552 11.87 25 13.1854 25 14.5569V23.0007H6L6 12.334Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.50066C8.27614 7.50066 8.5 7.72451 8.5 8.00066L8.5 19.5007L20.5 19.5007C22.2312 19.5007 23.8613 20.3157 24.9 21.7007L26.4 23.7007C26.5657 23.9216 26.5209 24.235 26.3 24.4007C26.0791 24.5663 25.7657 24.5216 25.6 24.3007L24.1 22.3007C23.2502 21.1675 21.9164 20.5007 20.5 20.5007L8.25 20.5007L5.4 24.3007C5.23432 24.5216 4.92091 24.5663 4.7 24.4007C4.47909 24.235 4.43432 23.9216 4.6 23.7007L7.5 19.834L7.5 8.00066C7.5 7.72451 7.72386 7.50066 8 7.50066Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangularOpBeveledRight);
export default __webpack_public_path__ + "static/media/rectangular-op-beveled-right.a7c4e807.svg";
export { ForwardRef as ReactComponent };